import { Modal, Textarea } from "@mantine/core";
import PropTypes from "prop-types";
import { useForm } from "@mantine/form";
import { TextInput, Button, Box, Group, Text } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { useState } from "react";
import { deleteTaskApi, editTaskApi } from "../../api/tasks";
import { showNotification, updateNotification } from "@mantine/notifications";

function EditModal({ open, setOpen, task }) {
  const [checkButton, setcheckButton] = useState(0);
  const handleForm = async (values) => {
    showNotification({
      id: "EditTask",
      title: "Editing Task",
      loading: true,
      autoClose: false,
      disallowClose: true,
    });
    const formData = new FormData();

    formData.append("taskId", values.taskId);
    formData.append("title", values.name);
    formData.append("content", values.content);
    formData.append("taskNo", values.taskNo);
    formData.append("deadline", values.deadline);
    formData.append("domain", values.domain);
    formData.append("subAllowed", values.subAllowed);
    formData.append("showResult", values.showResult);
    formData.append("evalNotes", values.evalNotes);
    if (values.task != "") {
      const file = document.querySelector("#fileInput");
      formData.append("task", file.files[0]);
    }

    const res = await editTaskApi(formData).catch((err) => {
      updateNotification({
        id: "EditTask",
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403 ){
        if( err.response.data.message=="No token"||err.response.data.message=="Invalid token or Token expired" || err.response.data.message== "Token expired"){
          localStorage.clear();
          window.location.replace("/");}
      }
      return;
    });
    if (res != null) {
      if (res.status == 200) {
        updateNotification({
          id: "EditTask",
          title: "Success",
          message: res.data.message,
          color: "green",
        });
        setcheckButton(0);
      location.reload();
      } else {
        updateNotification({
          id: "EditTask",
          title: "ERROR",
          message: res.data.message,
          color: "red",
        });
        return;
      }
    }
    setcheckButton(0);
    //location.reload();
  };
  const handleForm2 = async (taskId) => {
    showNotification({
      id: "DelTask",
      title: "Deleting Task",
      loading: true,
      autoClose: false,
      disallowClose: true,
    });
    const res = await deleteTaskApi(taskId).catch((err) => {
      updateNotification({
        id: "DelTask",
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        if( err.response.data.message=="No token"||err.response.data.message=="Invalid token or Token expired" || err.response.data.message== "Token expired"){
          localStorage.clear();
          window.location.replace("/");}
        
      }
      return;
    });
    if (res != null) {
      if (res.status == 200) {
        updateNotification({
          id: "DelTask",
          title: "Success",
          message: res.data.message,
          color: "green",
        });
        setcheckButton(0);
      location.reload();
      } else {
        updateNotification({
          id: "DelTask",
          title: "ERROR",
          message: res.data.message,
          color: "red",
        });
        return;
      }
    }
    setcheckButton(0);
    //location.reload();
  };
  const initialValue =
    "<p>Your initial <b>html value</b> or an empty string to init editor without value</p><br><br><br><br>";
  const [value, onChange] = useState(initialValue);

  const form = useForm({
    initialValues: {
      taskId: task.id,
      name: task.title,
      taskNo: task.taskNo,
      content: task.content,
      deadline: task.deadline,
      domain: task.domainName,
      evalNotes: task.evalNotes,
      subAllowed: task.subAllowed,
      showResult: task.showResult,
      task: "",
    },
  });
  return (
    <Modal
      opened={open}
      onClose={() => setOpen(false)}
      size="100%"
      overflow="inside"
      title="Edit Task"
    >
      <Box mx="auto">
        <form
          onSubmit={form.onSubmit((values) => {
            //console.log(values);
            if (checkButton == 2) handleForm(values);
            else if (checkButton == 1) {
              handleForm2(values.taskId);
            }
            setOpen(false);
          })}
        >
          <TextInput
            required
            label="Task Name:"
            placeholder="Enter Task Name"
            mt="sm"
            {...form.getInputProps("name")}
          />

          <Text style={{ marginTop: "10px", fontWeight: "500" }}>Content:</Text>
          <Textarea
          value={value}
          onChange={onChange}
            required
            mt="sm"
            minRows={4}
            {...form.getInputProps("content")}
          />

          <Textarea
            required
            label="Evaluation Notes::"
            placeholder="Enter Eval Notes"
            mt="sm"
            minRows={4}
            {...form.getInputProps("evalNotes")}
          />

          <DatePicker
            placeholder="Pick date"
            label="Deadline:"
            required
            mt="sm"
            defaultValue={new Date(task.deadline)}
            {...form.getInputProps("deadline")}
          />
          <br></br>
          <Text styles={{ color: "white" }}>
            NOTE : Upload new task file, only if you want to override the pre existing file.
          </Text>

          <Text style={{ marginTop: "10px", fontWeight: "500" }}>
            Add Task File:
          </Text>

          <input
            type="file"
            id="fileInput"
            name="task"
            {...form.getInputProps("task")}
            accept="image/zip"
          />

          <Group position="right" mt="xl">
            <Button
              type="submit"
              style={{ background: "red" }}
              onClick={() => setcheckButton(1)}
            >
              Delete
            </Button>
            <Button type="submit" onClick={() => setcheckButton(2)}>
              Submit
            </Button>
          </Group>
        </form>
      </Box>
    </Modal>
  );
}

EditModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.bool,
  task: PropTypes.object,
};

export default EditModal;
